import { forwardRef, lazy, Suspense, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
// Hero entrance moved to CSS to avoid Framer Motion delaying LCP.
// import { motion, useReducedMotion } from "framer-motion";
import "../styles/banner.css";
import { trackEvent } from "../utils/analytics";
import heroHandPoster from "../assets/hero-hand-poster-mobile1.webp";
// Perf: replaced eager 3D import with lazy deferred loading.
// import { HeroHand3D } from "./HeroHand3D";
const HeroHand3D = lazy(() =>
  import("./HeroHand3D").then((m) => ({ default: m.HeroHand3D })),
);
// import computerBg from "../assets/computer-bg.webp"; // LAPTOP PNG
// import phoneMockup from "../assets/3d-hand-hero2.png";
// import useMousePosition from "./feature/UseMousePosition";



// ── Animation variants ────────────────────────────────────────────────────────
// const EASE_OUT_CUBIC = [0.215, 0.61, 0.355, 1.0];

// const containerVariants = {
//   hidden: {},
//   visible: {
//     transition: {
//       staggerChildren: 0.12,
//       delayChildren: 0.1,
//     },
//   },
// };

// const childVariants = {
//   hidden: { opacity: 0, y: 30, filter: "blur(10px)" },
//   visible: {
//     opacity: 1,
//     y: 0,
//     filter: "blur(0px)",
//     transition: { duration: 0.75, ease: EASE_OUT_CUBIC },
//   },
// };

// const containerVariants = {
//   hidden: {},
//   visible: {
//     transition: {
//       staggerChildren: 0.18,
//       delayChildren: 0.15,
//     },
//   },
// };

// const childVariants = {
//   hidden: { opacity: 0, y: 50, filter: "blur(20px)" },
//   visible: {
//     opacity: 1,
//     y: 0,
//     filter: "blur(0px)",
//     transition: { duration: 1.0, ease: [0.25, 0.1, 0.25, 1.0] },
//   },
// };

// Hero entrance now runs in CSS with matching delays/easing.
// const containerVariants = {
//   hidden: {},
//   visible: {
//     transition: {
//       staggerChildren: 0.18,
//       delayChildren: 0.15,
//     },
//   },
// };

// const childVariants = {
//   hidden: { opacity: 0, y: 50 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 1.0, ease: [0.25, 0.1, 0.25, 1.0] },
//   },
// };

// const wordVariants = {
//   hidden: { opacity: 0, y: 40 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.85, ease: [0.25, 0.1, 0.25, 1.0] },
//   },
// };

// const wordContainerVariants = {
//   hidden: {},
//   visible: {
//     transition: {
//       staggerChildren: 0.08,
//     },
//   },
// };

// const buttonVariants = {
//   hidden: { opacity: 0, y: 30 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1.0] },
//   },
// };

// const buttonContainerVariants = {
//   hidden: {},
//   visible: {
//     transition: {
//       staggerChildren: 0.12,
//     },
//   },
// };

// Instant (no-motion) variants — used when prefers-reduced-motion is set
// Hero entrance reduced motion now comes from CSS.
// const noMotionVariants = {
//   hidden: {},
//   visible: {},
// };

// ── Helpers ───────────────────────────────────────────────────────────────────
const HERO_HEADLINE_LINES = [
  "I build fast,",
  "polished websites",
  "and web apps.",
];

function HeroHandPoster() {
  const [shouldShowPoster, setShouldShowPoster] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 991px)").matches
      : false,
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const mobileQuery = window.matchMedia("(max-width: 991px)");
    const syncPosterVisibility = () => {
      setShouldShowPoster(mobileQuery.matches);
    };

    syncPosterVisibility();

    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", syncPosterVisibility);
      return () => {
        mobileQuery.removeEventListener("change", syncPosterVisibility);
      };
    }

    mobileQuery.addListener(syncPosterVisibility);
    return () => {
      mobileQuery.removeListener(syncPosterVisibility);
    };
  }, []);

  return (
    <div className="home-hero__phone-placeholder" aria-hidden="true">
      {shouldShowPoster && (
        <img
          src={heroHandPoster}
          alt=""
          className="home-hero__phone-poster"
          width="248"
          height="293"
          loading="eager"
          decoding="async"
        />
      )}
    </div>
  );
}

// LCP: the old per-word stagger split the headline into many animated spans.
// const HERO_HEADLINE_WORD_STARTS = HERO_HEADLINE_LINES.reduce(
//   (starts, line, index, lines) => {
//     starts.push(
//       index === 0 ? 0 : starts[index - 1] + lines[index - 1].split(" ").length,
//     );
//     return starts;
//   },
//   [],
// );

// Hero entrance moved to CSS; keeping the old Framer Motion word renderer as a comment.
// function AnimatedWords({ text, variants: v }) {
//   return text.split(" ").map((word, i) => (
//     <motion.span
//       key={i}
//       className="home-hero__word"
//       variants={v}
//     >
//       {word}&nbsp;
//     </motion.span>
//   ));
// }

// LCP: the old renderAnimatedWords helper staggered opacity on each word.
// function renderAnimatedWords(text, startIndex) {
//   return text.split(" ").map((word, index) => {
//     const wordIndex = startIndex + index;
//     const animationDelay = 0.2 + wordIndex * 0.05;
//
//     return (
//       <span
//         key={`${text}-${wordIndex}`}
//         className="home-hero__word hero-anim-word"
//         style={{ animationDelay: `${animationDelay}s` }}
//       >
//         {word}&nbsp;
//       </span>
//     );
//   });
// }

// ── Component ─────────────────────────────────────────────────────────────────
function useDeferredMount() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const isMobile = window.matchMedia("(max-width: 991px)").matches;
    const lcpSettleDelay = isMobile ? 900 : 650;
    const fallbackDelay = isMobile ? 3200 : 2600;
    let fallbackId = 0;
    let settleId = 0;
    let idleId = 0;
    let cancelled = false;
    let mountQueued = false;
    let observer;

    const markReady = () => {
      if (!cancelled) {
        setReady(true);
      }
    };

    const queueIdleMount = () => {
      if (cancelled || mountQueued) return;
      mountQueued = true;

      if ("requestIdleCallback" in window) {
        idleId = window.requestIdleCallback(() => markReady(), {
          timeout: isMobile ? 2200 : 1600,
        });
        return;
      }

      idleId = window.setTimeout(markReady, isMobile ? 240 : 180);
    };

    const disconnectObserver = () => {
      if (observer) {
        observer.disconnect();
        observer = undefined;
      }
    };

    const scheduleAfterLcp = () => {
      window.clearTimeout(settleId);
      settleId = window.setTimeout(() => {
        disconnectObserver();
        queueIdleMount();
      }, lcpSettleDelay);
    };

    /* Perf: replaced the old idle-only mount because it could still fire before LCP.
    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(() => setReady(true));

      return () => {
        if ("cancelIdleCallback" in window) {
          window.cancelIdleCallback(idleId);
        }
      };
    }

    const timeoutId = window.setTimeout(() => setReady(true), 1500);
    return () => window.clearTimeout(timeoutId);
    */

    if ("PerformanceObserver" in window) {
      try {
        observer = new PerformanceObserver((list) => {
          if (list.getEntries().length > 0) {
            scheduleAfterLcp();
          }
        });
        observer.observe({ type: "largest-contentful-paint", buffered: true });
      } catch (_error) {
        scheduleAfterLcp();
      }
    } else {
      scheduleAfterLcp();
    }

    fallbackId = window.setTimeout(() => {
      disconnectObserver();
      queueIdleMount();
    }, fallbackDelay);

    return () => {
      cancelled = true;
      disconnectObserver();
      window.clearTimeout(fallbackId);
      window.clearTimeout(settleId);

      if ("cancelIdleCallback" in window) {
        window.cancelIdleCallback(idleId);
      } else {
        window.clearTimeout(idleId);
      }
    };
  }, []);

  return ready;
}

export const Header = forwardRef((_props, homeSection) => {
  const shouldMountHand3D = useDeferredMount();
  // const shouldReduceMotion = useReducedMotion();
  // const cv = shouldReduceMotion ? noMotionVariants : containerVariants;
  // const iv = shouldReduceMotion ? noMotionVariants : childVariants;
  // const wv = shouldReduceMotion ? noMotionVariants : wordVariants;
  // const wcv = shouldReduceMotion ? noMotionVariants : wordContainerVariants;
  // const bv = shouldReduceMotion ? noMotionVariants : buttonVariants;
  // const bcv = shouldReduceMotion ? noMotionVariants : buttonContainerVariants;
  // const mousePosition = useMousePosition();
  // const moveX =
  //   mousePosition.x != null
  //     ? (mousePosition.x / window.innerWidth - 0.5) * 40
  //     : 0;
  // const moveY =
  //   mousePosition.y != null
  //     ? (mousePosition.y / window.innerHeight - 0.5) * 30
  //     : 0;
  // const rotateY =
  //   mousePosition.x != null
  //     ? (mousePosition.x / window.innerWidth - 0.5) * 15
  //     : 0;
  // const rotateX =
  //   mousePosition.y != null
  //     ? (mousePosition.y / window.innerHeight - 0.5) * -10
  //     : 0;

  return (
    <section className="home-hero" id="home" ref={homeSection}>
      <div className="home-hero__bg" aria-hidden="true">
        <div className="home-hero__bg-base" />
        <div className="home-hero__bg-glow-violet" />
        <div className="home-hero__bg-glow-blue" />
        <div className="home-hero__bg-streaks" />

        <svg
          className="home-hero__bg-neon-geo"
          viewBox="0 0 1440 900"
          preserveAspectRatio="xMidYMid slice"
          aria-hidden="true"
        >
          <defs>
            <filter
              id="neon-glow-strong"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="b1" />
              <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="b2" />
              <feMerge>
                <feMergeNode in="b1" />
                <feMergeNode in="b1" />
                <feMergeNode in="b2" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <filter
              id="neon-glow-soft"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                in="SourceGraphic"
                stdDeviation="4"
                result="blur"
              />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <filter
              id="neon-fill-glow"
              x="-20%"
              y="-20%"
              width="140%"
              height="140%"
            >
              <feGaussianBlur in="SourceGraphic" stdDeviation="18" />
            </filter>
          </defs>

          {/* ── GROUP A — cool blue hexagons ── */}
          <g className="neon-geo__group-a">
            {/* A1 — Large hex, upper-right (cx=1240, cy=160, r=270) */}
            <path
              d="M 1240,-110 L 1474,25 L 1474,295 L 1240,430 L 1006,295 L 1006,25 Z"
              fill="#4A8FFF"
              fillOpacity="0.07"
              filter="url(#neon-fill-glow)"
              className="neon-hex__fill-a1"
            />
            <path
              d="M 1240,-110 L 1474,25 L 1474,295 L 1240,430 L 1006,295 L 1006,25 Z"
              fill="none"
              stroke="#5896FF"
              strokeWidth="1"
              strokeOpacity="0.22"
            />
            <path
              pathLength="100"
              d="M 1240,-110 L 1474,25 L 1474,295 L 1240,430 L 1006,295 L 1006,25 Z"
              fill="none"
              stroke="#7BBFFF"
              strokeWidth="2"
              strokeDasharray="28 72"
              filter="url(#neon-glow-strong)"
              className="neon-hex__stroke-a1"
            />

            {/* A2 — Medium hex, center-right (cx=960, cy=500, r=200) */}
            <path
              d="M 960,300 L 1133,400 L 1133,600 L 960,700 L 787,600 L 787,400 Z"
              fill="#4A8FFF"
              fillOpacity="0.06"
              filter="url(#neon-fill-glow)"
              className="neon-hex__fill-a2"
            />
            <path
              d="M 960,300 L 1133,400 L 1133,600 L 960,700 L 787,600 L 787,400 Z"
              fill="none"
              stroke="#5896FF"
              strokeWidth="0.8"
              strokeOpacity="0.18"
            />
            <path
              pathLength="100"
              d="M 960,300 L 1133,400 L 1133,600 L 960,700 L 787,600 L 787,400 Z"
              fill="none"
              stroke="#7BBFFF"
              strokeWidth="1.6"
              strokeDasharray="22 78"
              filter="url(#neon-glow-strong)"
              className="neon-hex__stroke-a2"
            />
          </g>

          {/* ── GROUP B — violet + cyan accent hexagons ── */}
          <g className="neon-geo__group-b">
            {/* B1 — Large violet hex, lower-right bleed (cx=1400, cy=680, r=250) */}
            <path
              d="M 1400,430 L 1617,555 L 1617,805 L 1400,930 L 1183,805 L 1183,555 Z"
              fill="#7C60FF"
              fillOpacity="0.06"
              filter="url(#neon-fill-glow)"
              className="neon-hex__fill-b1"
            />
            <path
              d="M 1400,430 L 1617,555 L 1617,805 L 1400,930 L 1183,805 L 1183,555 Z"
              fill="none"
              stroke="#7C60FF"
              strokeWidth="0.8"
              strokeOpacity="0.18"
            />
            <path
              pathLength="100"
              d="M 1400,430 L 1617,555 L 1617,805 L 1400,930 L 1183,805 L 1183,555 Z"
              fill="none"
              stroke="#9B80FF"
              strokeWidth="1.6"
              strokeDasharray="25 75"
              filter="url(#neon-glow-soft)"
              className="neon-hex__stroke-b1"
            />

            {/* B2 — Small cyan hex, right-edge bleed (cx=1480, cy=250, r=180) */}
            <path
              d="M 1480,70 L 1636,160 L 1636,340 L 1480,430 L 1324,340 L 1324,160 Z"
              fill="#40B8E0"
              fillOpacity="0.05"
              filter="url(#neon-fill-glow)"
              className="neon-hex__fill-b2"
            />
            <path
              d="M 1480,70 L 1636,160 L 1636,340 L 1480,430 L 1324,340 L 1324,160 Z"
              fill="none"
              stroke="#50C0E8"
              strokeWidth="0.7"
              strokeOpacity="0.16"
            />
            <path
              pathLength="100"
              d="M 1480,70 L 1636,160 L 1636,340 L 1480,430 L 1324,340 L 1324,160 Z"
              fill="none"
              stroke="#70D8FF"
              strokeWidth="1.4"
              strokeDasharray="20 80"
              filter="url(#neon-glow-soft)"
              className="neon-hex__stroke-b2"
            />
          </g>
        </svg>

        <div className="home-hero__bg-neon-sweep" />
        <div className="home-hero__bg-neon-bloom" />
        <div className="home-hero__bg-stars" />
        <div className="home-hero__bg-vignette" />
      </div>

      <div className="home-hero__nav-divider" aria-hidden="true" />

      <Container fluid className="home-hero__fluid">
        <div className="home-hero__inner px-3">
          <Row className="justify-content-center home-hero__shell-row">
            <Col lg={10} className="home-hero__shell-col">
              <Row className="align-items-center home-hero__row justify-content-between">
                <Col lg={6}>
                  {/* Hero entrance moved to CSS.
                  <motion.div
                    className="home-hero__content"
                    variants={cv}
                    initial="hidden"
                    animate="visible"
                  >
                  */}
                  <div className="home-hero__content">
                    {/* <motion.p
                      className="home-hero__eyebrow"
                      variants={iv}
                    >
                      FULL-STACK DEVELOPER
                    </motion.p> */}
                    <p className="home-hero__eyebrow hero-anim-eyebrow">
                      FULL-STACK DEVELOPER
                    </p>

                    {/* <motion.h1
                      className="home-hero__headline"
                      variants={{
                        hidden: {},
                        visible: {
                          transition: {
                            staggerChildren: 0.14,
                          },
                        },
                      }}
                    >
                      <motion.span className="home-hero__headline-line" variants={iv}>
                        I build fast,
                      </motion.span>
                      <motion.span className="home-hero__headline-line" variants={iv}>
                        polished websites
                      </motion.span>
                      <motion.span className="home-hero__headline-line" variants={iv}>
                        and web apps.
                      </motion.span>
                    </motion.h1> */}

                    {/* <motion.h1
                      className="home-hero__headline"
                      variants={wcv}
                    >
                      <span className="home-hero__headline-line">
                        <AnimatedWords text="I build fast," variants={wv} />
                      </span>
                      <span className="home-hero__headline-line">
                        <AnimatedWords text="polished websites" variants={wv} />
                      </span>
                      <span className="home-hero__headline-line">
                        <AnimatedWords text="and web apps." variants={wv} />
                      </span>
                    </motion.h1> */}
                    {/* LCP: removed per-word animated spans so the headline paints as one stable text block.
                    <h1 className="home-hero__headline">
                      <span className="home-hero__headline-line">
                        {renderAnimatedWords(
                          HERO_HEADLINE_LINES[0],
                          HERO_HEADLINE_WORD_STARTS[0],
                        )}
                      </span>
                      <span className="home-hero__headline-line">
                        {renderAnimatedWords(
                          HERO_HEADLINE_LINES[1],
                          HERO_HEADLINE_WORD_STARTS[1],
                        )}
                      </span>
                      <span className="home-hero__headline-line">
                        {renderAnimatedWords(
                          HERO_HEADLINE_LINES[2],
                          HERO_HEADLINE_WORD_STARTS[2],
                        )}
                      </span>
                    </h1> */}
                    <h1 className="home-hero__headline hero-anim-headline">
                      <span className="home-hero__headline-line">
                        {HERO_HEADLINE_LINES[0]}
                      </span>
                      <span className="home-hero__headline-line">
                        {HERO_HEADLINE_LINES[1]}
                      </span>
                      <span className="home-hero__headline-line">
                        {HERO_HEADLINE_LINES[2]}
                      </span>
                    </h1>

                    {/* <motion.p
                      className="home-hero__paragraph"
                      variants={iv}
                    >
                      Custom WordPress, React, and Node.js builds focused on
                      performance, clarity, and production-ready execution.
                    </motion.p> */}
                    {/* LCP: keeping the paragraph visible immediately, but restoring a transform-only entrance. */}
                    {/* Hero copy: added a desktop-only break so the line wrap stays stable before fonts/3D finish loading.
                    <p className="home-hero__paragraph hero-anim-para">
                      Custom WordPress, React, and Node.js builds focused on
                      performance, clarity, and production-ready execution.
                    </p> */}
                    <p className="home-hero__paragraph hero-anim-para">
                      Custom WordPress, React, and Node.js builds focused on
                      <br className="home-hero__paragraph-break" />
                      performance, clarity, and production-ready execution.
                    </p>

                    {/* <motion.div className="home-hero__cta" variants={iv}>
                      <a
                        href="#projects"
                        className="home-hero__btn home-hero__btn--primary"
                      >
                        View Projects
                      </a>
                      <a
                        href="#contacts"
                        className="home-hero__btn home-hero__btn--secondary"
                      >
                        Let’s Talk
                      </a>
                    </motion.div> */}

                    {/* <motion.div className="home-hero__cta" variants={bcv}> */}
                    <div className="home-hero__cta">
                      {/* <motion.a
                        href="#projects"
                        className="home-hero__btn home-hero__btn--primary"
                        variants={bv}
                      > */}
                      <a
                        href="#projects"
                        className="home-hero__btn home-hero__btn--primary hero-anim-cta-btn"
                        onClick={() => {
                          trackEvent("click_view_projects", {
                            location: "hero",
                            button_text: "View Projects",
                          });
                        }}
                      >
                        View Projects
                      {/* </motion.a> */}
                      </a>
                      {/* <motion.a
                        href="#contacts"
                        className="home-hero__btn home-hero__btn--secondary"
                        variants={bv}
                      > */}
                      <a
                        href="#contacts"
                        className="home-hero__btn home-hero__btn--secondary hero-anim-cta-btn"
                        onClick={() => {
                          trackEvent("click_contact_cta", {
                            location: "hero",
                            button_text: "Contact Me",
                          });
                        }}
                      >
                        Let’s Talk
                      {/* </motion.a> */}
                      </a>
                    {/* </motion.div> */}
                    </div>

                    {/* <motion.p
                      className="home-hero__meta"
                      variants={iv}
                    > */}
                    <p className="home-hero__meta hero-anim-meta">
                      Custom builds&nbsp;•&nbsp;Clean code
                      <span className="home-hero__meta-sep" aria-hidden="true">
                        &nbsp;|&nbsp;
                      </span>
                      Performance-first
                    {/* </motion.p> */}
                    </p>
                  </div>
                  {/* </motion.div> */}
                </Col>

                {/* LAPTOP Second Option
              <Col lg={6} className="home-hero__visual-col">
                <div className="home-hero__visual">
                  <div className="home-hero__visual-inner">
                    <img
                      src={computerBg}
                      alt="Developer workspace"
                      className="home-hero__laptop"
                      width="920"
                      height="600"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </Col>
              */}

                <Col lg={6} className="home-hero__visual-col">
                  <div className="home-hero__visual">
                    <div className="home-hero__visual-inner">
                      {/*
                      <div
                        className="home-hero__phone-wrapper"
                        style={{
                          transform: `translate(${moveX}px, ${moveY}px) rotateY(${rotateY}deg) rotateX(${rotateX}deg)`,
                          transition: "transform 0.08s ease-out",
                          willChange: "transform",
                        }}
                      >
                        <span
                          className="home-hero__phone-merge"
                          aria-hidden="true"
                        />
                        <img
                          src={phoneMockup}
                          alt="Motola portfolio on mobile"
                          className="home-hero__phone"
                          loading="eager"
                          decoding="async"
                        />
                      </div>
                      */}
                      <div
                        className="home-hero__phone-wrapper"
                        style={{
                          width: "100%",
                          height: "600px",
                          transform: "none",
                          transition: "none",
                        }}
                      >
                        {/* Perf: replaced eager 3D mount with deferred lazy mount. <HeroHand3D /> */}
                        {shouldMountHand3D ? (
                          <Suspense
                            fallback={<HeroHandPoster />}
                          >
                            <HeroHand3D />
                          </Suspense>
                        ) : (
                          <HeroHandPoster />
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
});
